module.exports = __webpack_public_path__ + "img/lock-icon.310adbf6.svg";